import { css } from 'lit';

/** Theme: colors and fonts matching the WebGL palette */
export const colors = css`
  :host {
    --color-white: #ffffff;
    --color-cyan: #00ffff;
    --color-red: #ff0000;
    --color-dim: #4d4d4d;
    --color-very-dim: #262626;
    --color-bg-overlay: rgba(0, 0, 0, 0.85);
    --font-title: 'Audiowide', 'Noto Sans', system-ui, sans-serif;
    --font-body: 'Oxanium', 'Noto Sans', system-ui, sans-serif;
  }
`;

/** Common screen layout: centered content, full viewport */
export const screenLayout = css`
  :host {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    inset: 0;
    padding: env(safe-area-inset-top, 20px) env(safe-area-inset-right, 20px)
      env(safe-area-inset-bottom, 20px) env(safe-area-inset-left, 20px);
    pointer-events: auto;
    text-align: center;
  }
`;

/** Shared prompt styling (bottom of screen) */
export const promptStyle = css`
  .prompt {
    color: var(--color-red);
    font-size: 1.05rem;
    padding-bottom: 1rem;
  }
`;

/** Heading style */
export const headingStyle = css`
  .heading {
    font-family: var(--font-title);
    color: var(--color-white);
    font-size: 2.1rem;
    font-weight: bold;
    padding-top: 1rem;
    letter-spacing: 0.05em;
  }
  .subheading {
    color: var(--color-white);
    font-size: 1.1rem;
    margin-top: 0.5rem;
  }
`;

/** Story body text */
export const storyTextStyle = css`
  .story-text {
    color: var(--color-cyan);
    font-size: 1.15rem;
    line-height: 1.6;
    max-width: 600px;
    text-align: left;
    padding: 0 1rem;
  }
  .story-text p {
    margin: 0 0 1em 0;
  }
`;
